import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { soccerPath } from '../utils/paths';
import './TeamList.css';

const TeamList = () => {
  const { user } = useAuth();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadTeams = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAllTeams(user?.id);
      setTeams(data);
      setError('');
    } catch (err) {
      setError(err.message || 'Failed to load teams');
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    loadTeams();
  }, [loadTeams]);

  if (loading) {
    return <div className="loading">Loading teams...</div>;
  }

  if (error) {
    return <div className="alert alert-error">{error}</div>;
  }

  return (
    <div>
      <div className="card">
        <h2>All Teams ({teams.length})</h2>
        <button onClick={loadTeams} className="btn btn-secondary" style={{ marginBottom: '1rem' }}>
          Refresh
        </button>
      </div>

      {teams.length === 0 ? (
        <div className="empty-state">
          <h3>No teams created yet</h3>
          <p>Create your first team to get started!</p>
        </div>
      ) : (
        <div className="team-list">
          {teams.map((team) => (
            <Link key={team.id} to={soccerPath(`/teams/${team.id}`)} style={{ textDecoration: 'none' }}>
              <div className="team-card">
                <h3>{team.name}</h3>
                {team.description && (
                  <p style={{ color: '#666', marginBottom: '0.5rem' }}>{team.description}</p>
                )}
                <div className="team-info">
                  <strong>Creator:</strong> {team.creator.name}
                </div>
                <div className="team-info">
                  <strong>Total Players:</strong> {team.members.length}
                </div>
                <div className="team-info">
                  <strong>Divided Into:</strong> {team.numberOfTeams} teams
                </div>
                {team.divisions && team.divisions.length > 0 && (
                  <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #e0e0e0' }}>
                    <strong>Team Divisions:</strong>
                    {team.divisions.map((division, idx) => (
                      <div key={idx} style={{ marginTop: '0.5rem', color: '#666' }}>
                        {division.teamName}: {division.players.length} players
                        {division.averageSkill && (
                          <span style={{ marginLeft: '0.5rem', color: 'var(--color-brand)' }}>
                            (Avg Skill: {division.averageSkill.toFixed(1)})
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#999' }}>
                  Created: {new Date(team.createdAt).toLocaleDateString()}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamList;

